export default {
	"1": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error general"
		}
	},
	"2": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha perdido la sesión"
		}
	},
	"3": {
		"categoria" : 'important',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El usuario no es válido"
		}
	},
	"4": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se ha encontrado la oferta"
		}
	},
	"6": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta va dirigida a empleo"
		}
	},
	"7": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta va dirigida a prácticas"
		}
	},
	"8": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El dato existía previamente"
		}
	},
	"9": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El usuario se encuentra bloqueado"
		}
	},
	"10": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya es candidato/a a la oferta"
		}
	},
	"11": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Falta documentación necesaria"
		}
	},
	"12": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Se ha producido un error enviando el email"
		}
	},
	"13": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede gestionar la oferta"
		}
	},
	"14": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede pasar al estado seleccionado desde el actual"
		}
	},
	"15": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Faltan datos obligatorios"
		}
	},
	"16": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Hay otro usuario con ese ID"
		}
	},
	"17": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede inscribirse a la oferta porque se solapa con su práctica"
		}
	},
	"18": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede inscribirse a la oferta, es para estudiantes de grado"
		}
	},
	"19": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No puede inscribirse a la oferta, es para estudiantes de postgrado"
		}
	},
	"20": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No tiene servicio de empleo"
		}
	},
	"21": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No tiene servicio de prácticas"
		}
	},
	"22": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No está identificado como UTP ni como UTE"
		}
	},
	"23": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		}
	},
	"24": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Hay un problema con su empresa. Póngase en contacto con el administrador"
		}
	},
	"25": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		}
	},
	"26": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos/as para actualizar tu información"
		}
	},
	"27": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		}
	},
	"28": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La contraseña no es segura"
		}
	},
	"29": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya hay un contacto registrado en la empresa con este email"
		}
	},
	"30": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		}
	},
	"31": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se encuentra la candidatura"
		}
	},
	"32": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		}
	},
	"33": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El cif no tiene formato correcto"
		}
	},
	"34": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		}
	},
	"35": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no es accesible.",
			"to" : '/'
		}
	},
	"36": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no es para usuarios existentes.",
			"to" : '/'
		}
	},
	"37": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to" : '/'
		}
	},
	"38": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : " Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to" : '/'
		},

	},
	"39": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Ya has contestado esta encuesta",
			"to" : '/'
		}
	},
	"40": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Faltan preguntas por contestar"
		}
	},
	"42": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El enlace está caducado o ya ha sido utilizado"
		}
	},
	"41": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "No se encuentran los estudios de la titulación indicada"
		}
	},
	"44": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El email indicado pertenece a otra empresa, indique otro."
		}
	},
	"46": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La extensión del archivo no esta permitida"
		}
	},
	"48": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "La operación no está permitida"
		}
	},
	"49": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "Esta práctica no puede cambiar de estado"
		}
	},
	"66": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El Documento de Identidad no tiene formato válido"
		}
	},
	"500": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El servicio actualmente no esta disponible"
		}
	},
	"501": {
		"categoria" : 'medium',
		"es" : {
			"details" : "Practica que pasa de pendiente de evaluar a evaluada",
			"titulo" : "Enhorabuena",
			"cuerpo" : "La práctica ha sido marcada como evaluada correctamente",
			"to" : "/tutorados/en-evaluacion"
		}
	},
	"502": {
		"categoria" : 'medium',
		"es" : {
			"details" : "Practica se valida o se rechaza",
			"titulo" : "Enhorabuena",
			"cuerpo" : "Estado cambiado correctamente",
			"to" : "/validaciones/pendientes"
		}
	},
	"503": {
		"categoria" : 'medium',
		"es" : {
			"details" : "Practica que pasa de evaluada a pendiente de evaluar",
			"titulo" : "Enhorabuena",
			"cuerpo" : "La práctica ha sido marcada como pendiente de evaluar correctamente",
			"to" : "/tutorados/evaluados"
		}
	},
	"504": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Se ha enviado a tu email un correo para reestablecer tu contraseña",
			"to" : "/login"
		}
	},
	"505": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "Tu contraseña ha sido restablecida",
			"to" : "/login"
		}
	},
	"506": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Enhorabuena",
			"cuerpo" : "La oferta ha sido actualizada correctamente",
		}
	},

}



// WEBPACK FOOTER //
// ./src/errors/index.js